import { render, staticRenderFns } from "./SimpleHeadMenu.vue?vue&type=template&id=2fb322d3&scoped=true"
import script from "./SimpleHeadMenu.vue?vue&type=script&lang=js"
export * from "./SimpleHeadMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb322d3",
  null
  
)

export default component.exports